/** Lesbare Kurzfassung eines Formularwerts fuer den Konfliktdialog. */
function tipTapText(node: unknown): string {
  if (!node || typeof node !== "object") return ""
  const n = node as { text?: string; content?: unknown[] }
  if (typeof n.text === "string") return n.text
  return (n.content ?? []).map(tipTapText).filter(Boolean).join(" ")
}

function asText(value: unknown): string {
  if (value === null || value === undefined) return ""
  if (typeof value === "string") {
    const trimmed = value.trim()
    if (trimmed.startsWith("{\"type\":\"doc\"")) {
      try { return tipTapText(JSON.parse(trimmed)) } catch { return trimmed }
    }
    return trimmed
  }
  if (typeof value === "number" || typeof value === "boolean") return String(value)
  if (Array.isArray(value)) return value.map(asText).filter(Boolean).join(", ")
  if (typeof value === "object") {
    const o = value as Record<string, unknown>
    if (o.type === "doc") return tipTapText(o)
    for (const k of ["name", "text", "subject", "title", "label", "filename"]) {
      if (typeof o[k] === "string") return o[k] as string
    }
    return JSON.stringify(value)
  }
  return String(value)
}

export function conflictPreview(value: unknown, maxLength = 280): string {
  const text = asText(value)
  if (text === "") return "(leer)"
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text
}
